import { ReactNode } from 'react';
import { InformationCircleIcon } from '@heroicons/react/solid';

import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class AppliedIndexUpdateHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser) {
    super(history, user);
    this.action = 'updated';
  }

  displayText(): ReactNode {
    return (
      <>
        <b>{this.userName}</b> {this.action} an index
      </>
    );
  }

  detailText(): ReactNode {
    if (this.history.attributes?.migrated) {
      return this.history.attributes?.migrated.description;
    } else {
      return (
        <div data-testid="history-detail-text">
          The index{' '}
          <span className="font-semibold break-all">{this.history.attributes?.next.name}</span> with{' '}
          value {this.history.attributes?.prev.value} was {this.action} to{' '}
          {this.history.attributes?.next.value}.
        </div>
      );
    }
  }

  detailIcon(): ReactNode {
    return <InformationCircleIcon className="h-5 fill-support-info" />;
  }
}
